import type { RouteObject } from 'react-router';

import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { paths } from 'src/routes/paths';
import { ProtectedRoute } from 'src/routes/ProtectedRoute';

import DashboardLayout from 'src/layouts/dashboard';

const DashboardPage = lazy(() => import('src/pages/dashboard'));

export const dashboardRoutes: RouteObject[] = [
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: paths.dashboard,
        element: (
          <DashboardLayout>
            <Outlet />
          </DashboardLayout>
        ),
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={null}>
                <DashboardPage />
              </Suspense>
            ),
          },
        ],
      },
    ],
  },
];
